module.exports = __webpack_public_path__ + "img/geiz.2ea5de8d.png";